import { render, staticRenderFns } from "./ViewPhieuKham.vue?vue&type=template&id=7d75a4ee&scoped=true"
import script from "./ViewPhieuKham.vue?vue&type=script&lang=js"
export * from "./ViewPhieuKham.vue?vue&type=script&lang=js"
import style0 from "./ViewPhieuKham.vue?vue&type=style&index=0&id=7d75a4ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d75a4ee",
  null
  
)

export default component.exports